var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F3F3F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7247 23.7247C23.9688 23.4806 24.3645 23.4806 24.6086 23.7247L27.9419 27.0581C28.186 27.3021 28.186 27.6979 27.9419 27.9419C27.6979 28.186 27.3021 28.186 27.0581 27.9419L23.7247 24.6086C23.4806 24.3645 23.4806 23.9688 23.7247 23.7247Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 13.125C15.8299 13.125 13.125 15.8299 13.125 19.1667C13.125 22.5034 15.8299 25.2083 19.1667 25.2083C20.8381 25.2083 22.35 24.5304 23.4445 23.4331C24.5351 22.3395 25.2083 20.8323 25.2083 19.1667C25.2083 15.8299 22.5034 13.125 19.1667 13.125ZM11.875 19.1667C11.875 15.1396 15.1396 11.875 19.1667 11.875C23.1937 11.875 26.4583 15.1396 26.4583 19.1667C26.4583 21.1765 25.6443 22.9975 24.3295 24.3158C23.0101 25.6387 21.1835 26.4583 19.1667 26.4583C15.1396 26.4583 11.875 23.1937 11.875 19.1667Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedIcon);
export default __webpack_public_path__ + "static/media/featured_icon.1de83ef6ea277257119dad91b39020e5.svg";
export { ForwardRef as ReactComponent };